import { EpimsBaseEntityDto } from './epim-base.dto';
export class SeismicDamageListDto extends EpimsBaseEntityDto {
    
    ItemName: string;
    OTPApprovedRate: number;
    OptApprovedDate: Date;
    CompanyApprovedRate: number;

  SubscriptionUserId: string;
  Version: number;
}
